import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const counterpartyRoutes = {
  path: "/counterparty",
  component: layout,
  name: "counterparty",
  meta: {
    breadcrumb: [{ name: 'counterparties', route: "counterparty.index" }],
    middleware: auth
  },
  children: [
    {
      path: "",
      component: () => import("~/views/Counterparty/Index"),
      name: "counterparty.index",
      meta: {
        breadcrumb: [{ name: "breadcrumb.overview" }],
        middleware: auth
      }
    },
    {
      path: "create",
      component: () => import("~/views/Counterparty/Create"),
      name: "counterparty.create",
      meta: {
        breadcrumb: [
          { name: 'counterparties', route: "counterparty.index" },
          { name: 'breadcrumb.create' }
        ],
        middleware: auth
      }
    },
    {
      path: ":counterpartyId/update",
      component: () => import("~/views/Counterparty/Edit.vue"),
      name: "counterparty.update",
      meta: {
        breadcrumb: [
          { name: 'counterparties', route: "counterparty.index" },
          { name: 'breadcrumb.edit' }
        ],
        middleware: auth
      }
    }
  ]
};

export default counterpartyRoutes;
